import { CartesianGrid, LabelList, Legend, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { TurnoverResult } from "models/hr-dashboard";

interface TurnoverChartProps {
    data: TurnoverResult;
}

const toPct = (n: number | null) => (n === null ? null : Math.round(n * 1000) / 10);

// Monthly turnover % with the quarterly maximum as a dashed reference line.
const TurnoverChart = ({ data }: TurnoverChartProps) => {
    const rows = data.months
        .filter(m => m.values)
        .map(m => ({ label: m.label, rate: toPct(m.values!.rate) }));

    if (rows.length === 0) return null;

    const max = toPct(data.quarterMax) ?? 0;

    return (
        <div style={{ width: "100%" }}>
            <h4 className="text-muted mb-2">Monthly Turnover</h4>
            <div style={{ width: "100%", height: 350 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={rows} margin={{ top: 20, right: 30, left: 10, bottom: 10 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="label" />
                        <YAxis tickFormatter={(v: number) => `${v}%`} domain={[0, (m: number) => Math.ceil(Math.max(m, max) + 1)]} />
                        <Tooltip formatter={(v: number) => `${v}%`} />
                        <Legend />
                        <ReferenceLine y={max} stroke="#dc3545" strokeDasharray="6 4" label={{ value: `Max ${max}%`, position: "right", fill: "#dc3545" }} />
                        <Line type="monotone" dataKey="rate" name="Month Turnover" stroke="#29A9E0" strokeWidth={2}>
                            <LabelList dataKey="rate" position="top" formatter={(v: number) => `${v}%`} />
                        </Line>
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default TurnoverChart;
